<template>
  <div class="live-card" :class="{'one-live-card': liveCount === 1}">
    <div class="left">
      <span class="living-btn" v-if="liveData.live_status == '2'">直播中</span>
      <img :src="liveData.live_cover_url || require('../../../assets/images/video_cover.jpg')" alt="">
    </div>
    <div class="right one-live" v-if="liveCount === 1">
      <div class="live-info">
        <div>
          <p class="live-name text-overflow">{{ liveData.live_name }}</p>
        <div class="teacher-school"><span>{{ liveData.lecturer }}</span><span class="split" v-if="liveData.lecturer && liveData.school_name"></span><span>{{ liveData.school_name }}</span></div>
        </div>
        <div class="time">{{ $utils.formatDate(liveData.start_time, 'MM月DD日 hh:mm') }} - {{ $utils.formatDate(liveData.end_time, 'MM月DD日 hh:mm') }}</div>
      </div>
      <div class="status-watch" v-if="liveData.live_status == '2'" @click="goDetail(liveData.id)">观看直播</div>
      <div class="status-start" v-if="liveData.live_status !== '2'">未开始</div>
    </div>
    <div class="right" v-else>
      <p class="live-name text-overflow">{{ liveData.live_name }}</p>
      <div class="teacher-school"><span>{{ liveData.lecturer }}</span><span class="split" v-if="liveData.lecturer && liveData.school_name"></span><span>{{ liveData.school_name }}</span></div>
      <div class="time">{{ $utils.formatDate(liveData.start_time, 'MM月DD日 hh:mm') }} - {{ $utils.formatDate(liveData.end_time, 'MM月DD日 hh:mm') }}</div>
      <div class="status-watch" v-if="liveData.live_status == '2'" @click="goDetail(liveData.id)">观看直播</div>
      <div class="status-start" v-if="liveData.live_status !== '2'">未开始</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveCard',
  props: {
    liveData: Object,
    menu: Object,
    liveCount: Number, // 直播数量
  },
  data() {
    return {
      status: 0
    }
  },
  methods: {
    goDetail(id) {
      window.open(`/liveDetail.html?menuId=${this.menu.id}&name=${this.menu.menu_name}&id=${id}`)
    }
  }
}
</script>

<style scoped lang="scss">
$color: #0C53A2;
.live-card {
  display: flex;
  width: 560px;
  padding-top: 16px;
  margin-right: 20px;
  .left {
    width: 240px;
    height: 136px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .living-btn {
      display: inline-block;
      width: 64px;
      height: 28px;
      background: #FF581D;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 28px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .right {
    padding-left: 24px;
    .live-name {
      width: 280px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
      line-height: 22px;
    }
    .teacher-school {
      display: flex;
      margin-top: 6px;
      height: 17px;
      justify-items: center;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 17px;
      .split {
        display: inline-block;
        margin-left: 8px;
        margin-top: 1px;
        height: 14px;
        padding-right: 8px;
        border-left: 1px solid #666;
      }
      
    }
    .time {
      margin-top: 26px;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: $color;
      line-height: 17px;
    }
    .status-watch {
      margin-top: 9px;
      width: 130px;
      height: 34px;
      background: $color;
      border-radius: 18px;
      color: #fff;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: center;
      line-height: 34px;
      cursor: pointer;
    }
    .status-start {
      margin-top: 9px;
      width: 130px;
      height: 34px;
      border: 1px solid #ddd;
      border-radius: 18px;
      color: $color;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: center;
      line-height: 34px;
    }
  }
  .one-live {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .live-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      padding-bottom: 10px;
    }
  }
}

.one-live-card {
  margin-right: 0;
  width: 100%;
}
</style>